/** Canonical UI provider key for Slack messaging + search tools. */
export const SLACK_PROVIDER_KEY = 'slack';

/** Legacy provider segment in tool keys (`slacksearch/...`) and legacy credential accounts. */
export const SLACKSEARCH_PROVIDER_KEY = 'slacksearch';

export const usesCocoSlackInstall = (providerKey: string): boolean =>
  providerKey === SLACK_PROVIDER_KEY ||
  providerKey === SLACKSEARCH_PROVIDER_KEY;
